<template>
  <input type="text" />
</template>
<script src="./index.js"></script>
